export default __webpack_public_path__ + "static/media/iconCenterGPSBlack.b2f150ef.svg";